import React from 'react';
import './css/UniqueFeatures.css';

// Reusing your standalone, modular layout components
import Navbar from './components/Navbar';
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';

// Import your custom images here
import uniqueHeroBg from '../images/banner-unique-features.jpg';
import featureSectionBg from '../images/Banner9.png';

// Feature & Timeline Image Imports
import Why1 from '../images/fsd-icon.png';
import Why2 from '../images/cmc-icon.png';
import Why3 from '../images/psc-icon.png';
import Why4 from '../images/forumicon3.png';
import Why5 from '../images/associate-icon.jpg';
import Why6 from '../images/soft-icon.jpg';
import Why7 from '../images/forumicon2.png';
import Why8 from '../images/kirnavaliicon.png';
import DownloadApp from './components/DownloadApp';

function UniqueFeatures() {
    return (
        <div className="unique-features-page-wrapper">

            {/* 1. Header Hero Section with integrated clean Navbar */}
            <section
                className="unique-hero-section"
                style={{ backgroundImage: `url(${uniqueHeroBg})` }}
            >
                <Navbar />
            </section>

            {/* 2. Compact Sleek Alternating Timeline Section */}
            <section
                className="unique-timeline-section"
                style={{ backgroundImage: `url(${featureSectionBg})` }}
            >
                <div className="container py-4">
                    <div className="row justify-content-center text-center mb-4">
                        <div className="col-lg-8">
                            <span className="grid-section-mini-tag">OUR KEY FEATURES</span>

                            <h2 className="grid-section-heading" style={{ color: '#207AB4' }}>
                                Discover What Makes Crestest Different
                            </h2>

                            <div className="zigzag-border mx-auto mt-2"></div>
                        </div>
                    </div>

                    <div className="timeline-wrapper position-relative">
                        {/* Center Straight Vertical Line */}
                        <div className="timeline-center-line"></div>

                        {/* Timeline Item 1: Facilitate Self Discovery (FSD) */}
                        <div className="timeline-row row align-items-center mb-3">
                            <div className="col-lg-6 col-md-6 text-lg-end text-md-end text-center mb-2 mb-lg-0">
                                <div className="timeline-box timeline-box-left position-relative d-inline-block">
                                    <div className="timeline-arrow-right"></div>
                                    <img src={Why1} alt="Facilitate Self Discovery" className="timeline-box-img" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 text-lg-start text-md-start text-center">
                                <div className="timeline-box timeline-box-right position-relative d-inline-block">
                                    <div className="timeline-arrow-left"></div>
                                    <span className="timeline-badge-tag">PREMIER LEARNING HUB</span>
                                    <h3 className="timeline-box-heading">Facilitate Self Discovery (FSD)</h3>
                                    <p className="timeline-box-sub">
                                        Evaluate your academic level through online assessments and choose a personalized learning pathway that promotes self-awareness, responsibility, and independent learning.
                                    </p>
                                    <a 
                                        href="/online-exam" 
                                        rel="noopener noreferrer"
                                        className="timeline-action-btn text-decoration-none d-inline-block"
                                    >
                                        Learn More
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Timeline Item 2: Concept Maps & Content (CMC) */}
                        <div className="timeline-row row align-items-center mb-3 flex-row-reverse">
                            <div className="col-lg-6 col-md-6 text-lg-start text-md-start text-center mb-2 mb-lg-0">
                                <div className="timeline-box timeline-box-right position-relative d-inline-block">
                                    <div className="timeline-arrow-left"></div>
                                    <img src={Why2} alt="Concept Maps & Content" className="timeline-box-img" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 text-lg-end text-md-end text-center">
                                <div className="timeline-box timeline-box-left position-relative d-inline-block">
                                    <div className="timeline-arrow-right"></div>
                                    <span className="timeline-badge-tag">PREMIER LEARNING HUB</span>
                                    <h3 className="timeline-box-heading">Concept Maps & Content (CMC)</h3>
                                    <p className="timeline-box-sub">
                                        Structured concept maps and concise notes strengthen understanding, improve retention, and enhance performance in both school and competitive examinations.
                                    </p>
                                    <a 
                                        href="/e-library"  
                                        rel="noopener noreferrer"
                                        className="timeline-action-btn text-decoration-none d-inline-block"
                                    >
                                        Explore Content
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Timeline Item 3: Performance Score Card (PSC) */}
                        <div className="timeline-row row align-items-center mb-3">
                            <div className="col-lg-6 col-md-6 text-lg-end text-md-end text-center mb-2 mb-lg-0">
                                <div className="timeline-box timeline-box-left position-relative d-inline-block">
                                    <div className="timeline-arrow-right"></div>
                                    <img src={Why3} alt="Performance Score Card" className="timeline-box-img" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 text-lg-start text-md-start text-center">
                                <div className="timeline-box timeline-box-right position-relative d-inline-block">
                                    <div className="timeline-arrow-left"></div>
                                    <span className="timeline-badge-tag">PREMIER LEARNING HUB</span>
                                    <h3 className="timeline-box-heading">Performance Score Card (PSC)</h3>
                                    <p className="timeline-box-sub">
                                        Gain detailed insights through statistics and visual reports that highlight strengths, identify improvement areas, and track academic progress effectively.
                                    </p>
                                    <a 
                                        href="/performance-scorecard" 
                                        rel="noopener noreferrer"
                                        className="timeline-action-btn text-decoration-none d-inline-block"
                                    >
                                        View Scorecard
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Timeline Item 4a: Scholars' Forum - Group Discussion */}
                        <div className="timeline-row row align-items-center mb-3 flex-row-reverse">
                            <div className="col-lg-6 col-md-6 text-lg-start text-md-start text-center mb-2 mb-lg-0">
                                <div className="timeline-box timeline-box-right position-relative d-inline-block">
                                    <div className="timeline-arrow-left"></div>
                                    <img src={Why7} alt="Forum Group Discussion" className="timeline-box-img" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 text-lg-end text-md-end text-center">
                                <div className="timeline-box timeline-box-left position-relative d-inline-block">
                                    <div className="timeline-arrow-right"></div>
                                    <span className="timeline-badge-tag">SCHOLARS' FORUM</span>
                                    <h3 className="timeline-box-heading">Group Discussion</h3>
                                    <p className="timeline-box-sub">
                                        Collaborate with mentors and fellow learners in an interactive academic community that encourages peer discussions, innovation, and knowledge sharing.
                                    </p>
                                    <a 
                                        href="/group-discussion" 
                                        rel="noopener noreferrer"
                                        className="timeline-action-btn text-decoration-none d-inline-block"
                                    >
                                        Join Discussion
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Timeline Item 4b: Scholars' Forum - Quiz */}
                        <div className="timeline-row row align-items-center mb-3">
                            <div className="col-lg-6 col-md-6 text-lg-end text-md-end text-center mb-2 mb-lg-0">
                                <div className="timeline-box timeline-box-left position-relative d-inline-block">
                                    <div className="timeline-arrow-right"></div>
                                    <img src={Why4} alt="Forum Quiz" className="timeline-box-img" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 text-lg-start text-md-start text-center">
                                <div className="timeline-box timeline-box-right position-relative d-inline-block">
                                    <div className="timeline-arrow-left"></div>
                                    <span className="timeline-badge-tag">SCHOLARS' FORUM</span>
                                    <h3 className="timeline-box-heading">Quiz</h3>
                                    <p className="timeline-box-sub">
                                        Test your knowledge through engaging interactive quizzes designed to sharpen critical thinking, memory recall, and competitive readiness.
                                    </p>
                                    <a 
                                        href="/quiz" 
                                        rel="noopener noreferrer"
                                        className="timeline-action-btn text-decoration-none d-inline-block"
                                    >
                                        Take a Quiz
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Timeline Item 5: Kirnavali - National Academic Challenge */}
                        <div className="timeline-row row align-items-center mb-3 flex-row-reverse">
                            <div className="col-lg-6 col-md-6 text-lg-start text-md-start text-center mb-2 mb-lg-0">
                                <div className="timeline-box timeline-box-right position-relative d-inline-block">
                                    <div className="timeline-arrow-left"></div>
                                    <img src={Why8} alt="Kirnavali Challenge" className="timeline-box-img" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 text-lg-end text-md-end text-center">
                                <div className="timeline-box timeline-box-left position-relative d-inline-block">
                                    <div className="timeline-arrow-right"></div>
                                    <span className="timeline-badge-tag">KIRNAVALI</span>
                                    <h3 className="timeline-box-heading">National Academic Challenge</h3>
                                    <p className="timeline-box-sub">
                                        Participate in prestigious national-level academic challenges designed to test advanced intellect, competitive prowess, and scholastic mastery.
                                    </p>
                                    <a 
                                        href="/kirnavali" 
                                        rel="noopener noreferrer"
                                        className="timeline-action-btn text-decoration-none d-inline-block"
                                    >
                                        Explore Kirnavali
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Timeline Item 6: Institutional Association */}
                        <div className="timeline-row row align-items-center mb-3">
                            <div className="col-lg-6 col-md-6 text-lg-end text-md-end text-center mb-2 mb-lg-0">
                                <div className="timeline-box timeline-box-left position-relative d-inline-block">
                                    <div className="timeline-arrow-right"></div>
                                    <img src={Why5} alt="Association" className="timeline-box-img" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 text-lg-start text-md-start text-center">
                                <div className="timeline-box timeline-box-right position-relative d-inline-block">
                                    <div className="timeline-arrow-left"></div>
                                    <span className="timeline-badge-tag">ASSOCIATION</span>
                                    <h3 className="timeline-box-heading">Institutional Association</h3>
                                    <p className="timeline-box-sub">
                                        Partnering with schools and institutions to deliver secure online examinations, data-driven evaluations, and impactful academic outcomes.
                                    </p>
                                    <a 
                                        href="/associates" 
                                        rel="noopener noreferrer"
                                        className="timeline-action-btn text-decoration-none d-inline-block"
                                    >
                                        Partner With Us
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Timeline Item 7: Software Solutions */}
                        <div className="timeline-row row align-items-center flex-row-reverse">
                            <div className="col-lg-6 col-md-6 text-lg-start text-md-start text-center mb-2 mb-lg-0">
                                <div className="timeline-box timeline-box-right position-relative d-inline-block">
                                    <div className="timeline-arrow-left"></div>
                                    <img src={Why6} alt="Software Solutions" className="timeline-box-img" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 text-lg-end text-md-end text-center">
                                <div className="timeline-box timeline-box-left position-relative d-inline-block">
                                    <div className="timeline-arrow-right"></div>
                                    <span className="timeline-badge-tag">SOFTWARE</span>
                                    <h3 className="timeline-box-heading">Software Solutions</h3>
                                    <p className="timeline-box-sub">
                                        We develop AI-powered, cloud-native software solutions using modern technologies to deliver scalable, intelligent, and future-ready digital platforms.
                                    </p>
                                    <a 
                                        href="/software" 
                                        rel="noopener noreferrer"
                                        className="timeline-action-btn text-decoration-none d-inline-block"
                                    >
                                        Discover Solutions
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Download App Section */}
            <DownloadApp />

            {/* Bottom Global Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default UniqueFeatures;